import { render, staticRenderFns } from "./VehicleContractors.vue?vue&type=template&id=b86c8c6a&"
import script from "./VehicleContractors.vue?vue&type=script&lang=js&"
export * from "./VehicleContractors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports